module.exports = __webpack_public_path__ + "img/arrow-b.f96400ed.svg";